<template>
<v-container>
  <v-layout row wrap align-center>
    <v-flex sm12 md4 class="text-xs-center text-sm-center text-md-right">
      <img width="280" height="280" :src="logo" class="px-4 pb-4"></img>
    </v-flex>
    <v-flex sm12 md8>
      <h1 class="px-2 display-2 text-xs-center text-sm-center text-md-left"><b>{{ $t('app_name') }}</b></h1>
      <h4 class="px-2 accent--text title mt-3 mt-2 text-xs-center text-sm-center text-md-left">{{ $t('introduce.slogan') }}</h4>
      <v-container class="px-0 text-xs-center text-sm-center text-md-left">
        <v-btn round outline class="secondary--text" to="/client">{{ $t('introduce.what_apps_were_connected') }}</v-btn>
        <v-btn round outline class="secondary--text" to="/activity">{{ $t('introduce.what_actions_have_i_perform') }}</v-btn>
      </v-container>
    </v-flex>
  </v-layout>

  <v-layout row wrap align-baseline class="text-xs-center text-sm-center text-md-left px-2 mb-2">
    <h1 class="mr-3"><v-icon size="48" color="primary">record_voice_over</v-icon> {{ $t('introduce.voice') }}</h1>
    <h3 class="grey--text">{{ $t('introduce.voice_description') }}</h3>
  </v-layout>

  <v-layout row wrap class="mb-4 pb-4">
    <v-flex xs12 sm6 md4 v-for="p in partsVoice" :key="p.title">
      <v-card class="elevation-6 mx-2 my-2">
        <v-list two-line class="py-0">
          <v-list-tile @click="p.clickEvent">
            <v-list-tile-avatar tile>
              <img width="48" :src="p.img"></img>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ p.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-icon v-if="p.isNew" color="red">new_releases</v-icon>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>

  <v-layout row wrap align-baseline class="text-xs-center text-sm-center text-md-left px-2 mt-4 mb-2">
    <h1 class="mr-3"><v-icon size="48" color="primary">message</v-icon> {{ $t('introduce.message') }}</h1>
    <h3 class="grey--text">{{ $t('introduce.message_description') }}</h3>
  </v-layout>

  <v-layout row wrap class="mb-4">
    <v-flex xs12 sm6 md4 v-for="p in partsText" :key="p.title">
      <v-card class="elevation-6 mx-2 my-2">
        <v-list two-line class="py-0">
          <v-list-tile @click="p.clickEvent">
            <v-list-tile-avatar tile>
              <img width="48" :src="p.img"></img>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ p.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>

  <v-layout row justify-center class="pt-4">
    <v-btn flat color="grey" to="/terms">{{ $t('introduce.terms') }}</v-btn>
    <v-btn flat color="grey" to="/privacy">{{ $t('introduce.privacy') }}</v-btn>
    <v-btn flat @click="gotoSupport" color="grey">{{ $t('introduce.support') }}</v-btn>
  </v-layout>

</v-container>
</template>

<script>
import {
  LogoIcons
} from 'luffanet-web-components'

export default {
  name: 'Introduce',
  data: () => ({
    logo: LogoIcons.large,
    partsVoice: [{
      title: 'Amazon Alexa',
      img: require('../assets/alexa.png'),
      clickEvent: () => {
        window.open('https://console.luffanet.com.tw', '_blank');
      }
    }, {
      title: 'Google Assistant',
      img: require('../assets/assistant.png'),
      clickEvent: () => {
        window.open('https://console.luffanet.com.tw', '_blank');
      }
    }],
    partsText: [{
      title: 'Microsoft Skype',
      img: require('../assets/skype.png'),
      clickEvent: () => {
        window.open('https://join.skype.com/bot/485a92b4-5a0d-4f95-a416-fa549c66c222', '_blank');
      }
    }, {
      title: 'Line',
      img: require('../assets/line.png'),
      clickEvent: () => {
        window.open('https://console.luffanet.com.tw', '_blank');
      }
    }]
  }),
  methods: {
    gotoSupport() {
      window.open('https://luffanet.freshdesk.com/support/home', '_blank');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/introduce.vue